// Loads the audio samples for the provided sound kit and then sets the soundkit once loaded
export const LOAD_SOUND_KIT = 'LOAD_SOUND_KIT';
export const loadSoundKit = ({ soundKit, soundKitId }) => ({
   type: LOAD_SOUND_KIT,
   soundKit,
   soundKitId,
});

// Sets the sound kit in the sequencer
export const SET_SOUND_KIT = 'SET_SOUND_KIT';
export const setSoundKit = (soundKit) => ({
   type: SET_SOUND_KIT,
   soundKit,
});

// Sets the sound kit in the sequencer
export const ADD_SOUND_KIT = 'ADD_SOUND_KIT';
export const addSoundKit = (soundKit) => ({
   type: ADD_SOUND_KIT,
   soundKit,
});

/* Document events */

export const DOCUMENT_MOUSEUP = 'DOCUMENT_MOUSEUP';
export const documentMouseUp = (mouseButton) => ({
   type: DOCUMENT_MOUSEUP,
   mouseButton,
});

export const SET_COMPARE_ANSWER = 'SET_COMPARE_ANSWER';
export const setCompareAnswer = (compareAnswer) => ({
   type: SET_COMPARE_ANSWER,
   compareAnswer,
});

export const SET_HIGHLIGHTED_CONTROLS = 'SET_HIGHLIGHTED_CONTROLS';
export const setHighlightedControls = (highlightedControls) => ({
   type: SET_HIGHLIGHTED_CONTROLS,
   highlightedControls,
});
